"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var http_1 = require("@angular/common/http");
var router_1 = require("@angular/router");
var material_1 = require("@angular/material");
var lodash_1 = require("lodash");
var moment = require("moment");
var punch_card_service_1 = require("../punch-cards/punch-card.service");
var expense_service_1 = require("./expense.service");
var punch_card_filters_dialog_component_1 = require("../punch-cards/punch-card-filters-dialog.component");
var ExpensePunchCardsDialogComponent = /** @class */ (function () {
    function ExpensePunchCardsDialogComponent(route, router, punchCardService, expenseService, dialog, dialogRef) {
        this.route = route;
        this.router = router;
        this.punchCardService = punchCardService;
        this.expenseService = expenseService;
        this.dialog = dialog;
        this.dialogRef = dialogRef;
        this.selectedCount = 0;
        this.punchCards = [];
        this.allSelected = false;
        this.selectedPunchCards = [];
        this.excludePunchCards = [];
        this.loading = true;
        this.errors = [];
        this.routeToExpense = true;
        this.search = '';
        this.sortBy = '';
        this.sortAsc = true;
        this.filters = [];
        this.startDate = null;
        this.endDate = null;
        this.multipleActionDropdownOptions = [];
        this.menuOptions = [
            { name: 'Add to Expense', action: 'add', link: false }
        ];
    }
    ExpensePunchCardsDialogComponent.prototype.ngOnInit = function () {
        this.getPunchCards();
    };
    ExpensePunchCardsDialogComponent.prototype.onScroll = function (e) {
        var _this = this;
        if (!this.loading &&
            e.target.scrollTop > e.target.scrollHeight - e.target.clientHeight * 3) {
            var o = this.punchCardService.getNextCondensed();
            if (o) {
                this.loading = true;
                o.subscribe(function (punchCards) {
                    _this.punchCards = _this.punchCards.concat(punchCards);
                    _this.loading = false;
                }, function (err) { return _this.errors = err; }, function () {
                    _this.loading = false;
                });
            }
        }
    };
    ExpensePunchCardsDialogComponent.prototype.getPunchCards = function (query, append) {
        var _this = this;
        if (query === void 0) { query = {}; }
        if (append === void 0) { append = false; }
        if (!append) {
            this.punchCards = [];
        }
        this.loading = true;
        var order = (this.sortAsc ? '' : '-') + this.sortBy;
        var filters = this.filters.reduce(function (acc, filter) {
            return __assign({}, acc, filter.query);
        }, {});
        if (this.punchCardReq) {
            this.punchCardReq.unsubscribe();
        }
        if (this.startDate) {
            var date = new Date(this.startDate);
            query['start_time__gte'] = date.toISOString();
        }
        if (this.endDate) {
            var date = new Date(this.endDate);
            date.setHours(23, 59, 59, 999);
            query['start_time__lte'] = date.toISOString();
        }
        this.punchCardFilters = __assign({ ordering: order, search: this.search, unexpensed: 'True', completed: 'True', expenseable: 'True', exclude_cf: 'True' }, filters, query);
        this.punchCardReq = this.punchCardService.getCondensedPunchCards(this.punchCardFilters).subscribe(function (punchCards) {
            if (append) {
                _this.punchCards = _this.punchCards.concat(punchCards);
            }
            else {
                _this.punchCards = punchCards;
            }
            _this.count = _this.punchCardService.count;
            _this.loading = false;
        }, function (err) { return _this.errors = err; }, function () {
            _this.loading = false;
        });
    };
    ExpensePunchCardsDialogComponent.prototype.sort = function (sortKey) {
        if (this.sortBy === sortKey) {
            this.sortAsc = !this.sortAsc;
        }
        this.sortBy = sortKey;
        this.loading = true;
        this.getPunchCards({ ordering: (this.sortAsc ? '' : '-') + this.sortBy });
    };
    ExpensePunchCardsDialogComponent.prototype.customSort = function (sortParameter, sortKey) {
        var _a;
        if (this.sortParameter === sortParameter && this.sortBy === sortKey) {
            this.sortAsc = !this.sortAsc;
        }
        this.sortBy = sortKey;
        this.sortParameter = sortParameter;
        this.loading = true;
        this.getPunchCards((_a = {}, _a[this.sortParameter] = (this.sortAsc ? '' : '-') + this.sortBy, _a));
    };
    ExpensePunchCardsDialogComponent.prototype.changeSearch = function (term) {
        this.search = term || '';
        this.getPunchCards();
    };
    ExpensePunchCardsDialogComponent.prototype.expandSearch = function () {
        var _this = this;
        this.loading = true;
        setTimeout(function () {
            _this.search = '';
            _this.changeSearch();
        }, 1000);
    };
    ExpensePunchCardsDialogComponent.prototype.openFilters = function () {
        var _this = this;
        var dialog = this.dialog.open(punch_card_filters_dialog_component_1.PunchCardFiltersDialogComponent, {
            width: '430px'
        });
        dialog.componentInstance.callback = function (res) { return _this.filterChanges(res); };
        var startDate = lodash_1.get(lodash_1.find(this.filters, { key: 'startDate' }), 'value');
        if (startDate) {
            dialog.componentInstance.model.startDate = startDate;
        }
        var endDate = lodash_1.get(lodash_1.find(this.filters, { key: 'endDate' }), 'value');
        if (endDate) {
            dialog.componentInstance.model.endDate = endDate;
        }
        dialog.componentInstance.model.job = lodash_1.get(lodash_1.find(this.filters, { key: 'job' }), 'value');
        dialog.componentInstance.model.project = lodash_1.get(lodash_1.find(this.filters, { key: 'project' }), 'value');
        dialog.componentInstance.model.customer = lodash_1.get(lodash_1.find(this.filters, { key: 'customer' }), 'value');
        dialog.componentInstance.model.driver = lodash_1.get(lodash_1.find(this.filters, { key: 'driver' }), 'value');
        dialog.componentInstance.model.truck = lodash_1.get(lodash_1.find(this.filters, { key: 'truck' }), 'value');
        dialog.componentInstance.model = this.filters.reduce(function (acc, filter) {
            acc[filter.key] = filter.value;
            return acc;
        }, {});
        this.filtersDialog = dialog.componentInstance;
    };
    ExpensePunchCardsDialogComponent.prototype.filterChanges = function (filterRes) {
        // Callback from the filter dialog. Creates a collection of filters with the format: {key, value, query},
        // where 'key' is the filter type such as 'customer',
        // 'value' is the original object for the options that was select from the dropdown,
        // and 'query' is an object representing the query fragment associated with that filter setting.
        var queryKeys = {
            customer: 'jobevent__customer_organization',
            project: 'jobevent__job__project',
            payableTo: 'jobevent__owner_organization',
            job: 'jobevent__job',
            driver: 'driver',
            truck: 'truck',
            startDate: 'start_time__gte',
            endDate: 'start_time__lte',
            edited: 'edited',
            incomplete: 'completed',
            retake: 'retake_status'
        };
        var falseyFilters = [];
        this.filters = Object.keys(filterRes).map(function (key) {
            var query = {};
            var value = filterRes[key];
            var displayValue;
            if (typeof (value) === 'boolean') {
                if (key === 'incomplete' && value) {
                    displayValue = value.toString();
                    displayValue = displayValue.charAt(0).toUpperCase() + displayValue.slice(1);
                    value = !value;
                    var filterValue = value.toString();
                    filterValue = filterValue.charAt(0).toUpperCase() + filterValue.slice(1);
                    query[queryKeys[key]] = filterValue;
                }
                else if (key === 'retake' && value) {
                    value = 'requested';
                    query[queryKeys[key]] = value;
                }
                else if (value) {
                    value = value.toString();
                    value = value.charAt(0).toUpperCase() + value.slice(1);
                    query[queryKeys[key]] = value;
                }
            }
            else {
                query[queryKeys[key]] = filterRes[key] && filterRes[key].id;
            }
            var filter = {
                key: key,
                value: displayValue || value,
                query: query
            };
            if (filter.value === 'False' || !filter.value) {
                falseyFilters.push(filter);
            }
            return filter;
        });
        this.filters = lodash_1.difference(this.filters, falseyFilters);
        this.getPunchCards();
    };
    ExpensePunchCardsDialogComponent.prototype.removeFilter = function (filter) {
        lodash_1.remove(this.filters, filter);
        this.getPunchCards();
    };
    ExpensePunchCardsDialogComponent.prototype.menuAction = function (name, punchCard) {
        switch (name) {
            case 'add':
                this.addToExpense([punchCard.id]);
                break;
        }
    };
    ExpensePunchCardsDialogComponent.prototype.formattedDuration = function (startTime) {
        var duration = moment.duration(moment().diff(startTime));
        return duration.format('D[ days], H[ hrs], m[ mins]');
    };
    ExpensePunchCardsDialogComponent.prototype.selector = function (event, punchCard) {
        if (punchCard === void 0) { punchCard = null; }
        if (punchCard) {
            if (!event.target.checked) {
                punchCard.selected = false;
                lodash_1.pull(this.selectedPunchCards, punchCard.id);
                if (this.allSelected) {
                    this.excludePunchCards.push(punchCard.id);
                    this.selectedCount = (this.count - this.excludePunchCards.length);
                }
                else {
                    this.selectedCount = this.selectedPunchCards.length;
                }
            }
            else {
                punchCard.selected = true;
                if (this.allSelected) {
                    lodash_1.pull(this.excludePunchCards, punchCard.id);
                    this.selectedCount = (this.count - this.excludePunchCards.length);
                }
                else {
                    this.selectedPunchCards.push(punchCard.id);
                    this.selectedCount = this.selectedPunchCards.length;
                }
            }
        }
        else {
            if (!event.target.checked) {
                this.allSelected = false;
                this.punchCards.forEach(function (_punchCard) { _punchCard.selected = false; });
                this.selectedCount = 0;
            }
            else {
                this.allSelected = true;
                this.selectedCount = (this.count - this.excludePunchCards.length);
            }
            this.selectedPunchCards = [];
            this.excludePunchCards = [];
        }
    };
    ExpensePunchCardsDialogComponent.prototype.addToExpense = function (punchCards) {
        var _this = this;
        if (punchCards === void 0) { punchCards = null; }
        var model = {};
        if (this.expense && this.expense.id) {
            Object.assign(model, { id: this.expense.id });
            if (punchCards || this.selectedPunchCards.length) {
                Object.assign(model, { punchCards: punchCards || this.selectedPunchCards });
            }
            else if (this.allSelected) {
                var params_1 = new http_1.HttpParams();
                var filters_1 = lodash_1.omit(this.punchCardFilters, ['ordering', 'expense']);
                Object.keys(filters_1).map(function (key) {
                    if (filters_1[key].length) {
                        params_1 = params_1.set(key, filters_1[key]);
                    }
                });
                if (params_1.toString().length) {
                    Object.assign(model, {
                        filters: params_1.toString(), excludePunchCards: this.excludePunchCards
                    });
                }
            }
            this.expenseReq = this.expenseService.addToExpense(model, 'punchcards').subscribe(function (res) {
                _this.expense = res;
                _this.callback();
                _this.dialogRef.close();
            }, function (err) { return console.error(err); });
        }
        else {
            this.saveExpense();
        }
    };
    ExpensePunchCardsDialogComponent.prototype.saveExpense = function () {
        var _this = this;
        var model = {
            customerOrganization: this.expense.customerOrganization.id,
            punchCards: this.selectedPunchCards
        };
        this.expenseReq = this.expenseService.save(model).subscribe(function (res) {
            _this.expense = res;
            _this.dialogRef.close();
            if (_this.routeToExpense) {
                _this.router.navigate(['/expenses/' + _this.expense.id + '/edit']);
            }
        }, function (err) { return console.error(err); });
    };
    ExpensePunchCardsDialogComponent.prototype.onDateChanged = function (values, type) {
        if (values && values.length) {
            switch (type) {
                case 'startDate':
                    this.startDate = values[0];
                    break;
                case 'endDate':
                    this.endDate = values[0];
                    break;
            }
        }
        this.getPunchCards();
    };
    return ExpensePunchCardsDialogComponent;
}());
exports.ExpensePunchCardsDialogComponent = ExpensePunchCardsDialogComponent;
